import { PAYMENT_PROPERTY, } from "../index.js";
export const getCustomPaymentFromOrder = (order) => order.payment?.find((payment) => payment.__typename === "CustomPayment" &&
    payment.properties?.some(({ property }) => property === PAYMENT_PROPERTY.SHARED.IDENTIFIER)) ?? null;
export const getSharedPaymentProperty = (customPayment, property) => customPayment?.properties?.find(({ property: prop }) => prop === property)
    ?.value ?? null;
export const getOrderPaymentProperty = (customPayment, property) => customPayment?.properties?.find(({ property: prop }) => prop === property)
    ?.value ?? null;
export const getContractPaymentProperty = (customPayment, property) => customPayment?.properties?.find(({ property: prop }) => prop === property)
    ?.value ?? null;
export const getPaymentProviderFromOrder = (order) => getSharedPaymentProperty(getCustomPaymentFromOrder(order), PAYMENT_PROPERTY.SHARED.IDENTIFIER);
